<template>
  <div>
    <el-card>
      <el-form :model="infoForm" label-width="100px">
        <el-form-item label="课程名称">
          <el-input v-model="infoForm.title"></el-input>
        </el-form-item>
        <el-form-item label="课程介绍">
          <el-input v-model="infoForm.info"></el-input>
        </el-form-item>
        <el-form-item label="学时">
          <el-input v-model="infoForm.hour"></el-input>
        </el-form-item>
        <el-form-item label="价格（元）">
          <el-input v-model="infoForm.price"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <div style="float:left">
            <el-select v-model="value" placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item label="课程封面">
          <div style="float:left">
            <el-upload
                class="upload-demo"
                drag
                :http-request="handlePictureCardPreview"
                action="https://jsonplaceholder.typicode.com/posts/"
                multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过5M,建议尺寸400*220</div>
              <img v-if="fileUrl" :src="fileUrl" style="width: 100%;position: relative;top: -82%;height: 200px"/>
            </el-upload>
          </div>
        </el-form-item>

        <el-button type="primary" @click="submitUpload">上传课程</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {Message} from "element-ui";

export default {
  name: "AddGoods",
  data() {
    return {
      infoForm: {
        title: '',
        info: '',
        hour: '',
        price: '0'
      },
      options: '',
      value: '',
      fileList: [],
      upload:true,
      fileUrl:""
    }
  },
  created() {
    this.getCategory()
  },
  methods: {
    // 获取课程类别
    async getCategory() {
      const {data: res} = await this.$http.get("/category")
      this.options = res.data
    },

    //上传服务器
    submitUpload() {
      //判断是否有文件再上传
      if (this.fileList.length === 0) {
        return Message.error('请选取文件后再上传')
      }

      // 创建一个空的FormData对象:
      const formData = new FormData()
      // 使用FormData.append来添加键/值对到表单里面；
      formData.append('file', this.fileList.file)
console.log(this.fileList)

      // 添加自定义参数，不传可删除
      formData.append('title', this.infoForm.title)
      formData.append('info', this.infoForm.info)
      formData.append('hour', this.infoForm.hour)
      formData.append('price', this.infoForm.price)
      formData.append('type', this.value)
      console.log(formData)
      console.log(this.infoForm)
      // 发起请求
      this.$http.post('/courses/add', formData).then(res => {
        if (res.data.code === 1) {
          Message.success('上传成功');
          this.$router.push("/mg/courseManager/courses");
        } else {
          Message.error('上传失败');
        }
      })
    },
    handlePictureCardPreview(file) {

      var newarr = file.file.name.split('.')

      console.log(newarr[1])
      var newname = file.file.uid + '.' + newarr[1];
      var file1 = new File([file.file], newname);
      console.log(file1,'----------')
      file.file = file1;
      this.fileList = file;
      var size = file.file.size;
      if (size/1024/1024 > 5) {
        Message.error('圖片過大,上传失败');
      }
      console.log(file.file.uid)
      this.fileUrl = URL.createObjectURL(file.file); // 图片上传浏览器回显地址
      console.log(file)

      this.upload = false;
    }
  }
}

</script>

<style scoped>
</style>